import AxiosContent from '@/services/api/content/axios_content'

export default {
  createFolder: (params) => {
    return AxiosContent.post(`folder`, params)
  },
}
